import API from '../../app/services/API';

const api = new API();

export const getScope3 = async (currentProjectId, currentDate) => {
  return api.getScope3(currentProjectId, currentDate);
};
